import { render, staticRenderFns } from "./CampusEdit.vue?vue&type=template&id=4ab0ad98"
import script from "../../controllers/campus/campus-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus/campus-edit.js?vue&type=script&lang=js&external"
import style0 from "./CampusEdit.vue?vue&type=style&index=0&id=4ab0ad98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports